<template>
  <section class="two-col-content row">
    <!-- Start of list column -->
    <div class="panels" ref="panel-list" id="panel-list">
      <div class="row filter-holder">
        <div class="select">
          <div class="menu-icon" @click="showMenu">
            <div class="menu-icon-inner">
              <div class="top-bar bar"></div>
              <div class="mid-bar bar"></div>
              <div class="bottom-bar bar"></div>
            </div>
          </div>
          <el-select v-model="selectedCategory1" placeholder="Vertical" no-data-text="Vertical" popper-class="panel-select" @keydown.native="selectOption" filterable>
            <el-option label="All" value="*">All</el-option>
            <el-option
              v-for="category in categoryOne"
              v-if="category && category.length > 1"
              :key="category.id"
              :label="category.charAt(0).toUpperCase() + category.slice(1)"
              :value="category">{{ category.charAt(0).toUpperCase() + category.slice(1) }}
            </el-option>
          </el-select>
          <el-select v-model="selectedCategory2" placeholder="Country" no-data-text="Country" popper-class="panel-select" @keydown.native="selectOption" filterable>
            <el-option label="All" value="*">All</el-option>
            <el-option
                v-for="category in categoryTwo"
                v-if="category && category.length > 1"
                :label="category.charAt(0).toUpperCase() + category.slice(1)"
                :value="category"
                :key="category.id">{{ category.charAt(0).toUpperCase() + category.slice(1) }}
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="searchbar">
          <el-input
            placeholder="Search"
            v-model="searchText"
            :class="(currentView || '').indexOf('rotator') !== -1 && this.$store.state.user.affiliate_id != '0' ? 'mini-search-bar' : ''"
          >
          </el-input>
          <el-button v-if="(currentView || '').indexOf('rotator') !== -1 && this.$store.state.user.affiliate_id != '0'" 
              class="new-rotator-btn" @click="selectItem('create')" size="mini" round>
            Create <i class="el-icon-circle-plus"></i>
          </el-button>
        </div>
      </div>
      <div v-if="(currentView || '').indexOf('campaign') !== -1" class="row footer">stats reflect previous 7 days</div>
      <ul class="panel-items" v-loading="loading">
        <virtual-scroll :size="187" :remain="15" :bench="20" wtag="ul" class="virtual-scroll-container">
          <li v-if="filteredItems.length && !loading" :class="panelClass(item)"
              v-for="item in filteredItems" :key="item.id" @click="selectItem(item.id)">
            <keep-alive><component :is="currentListItemView" :item="item" :key="item.id"></component></keep-alive>
          </li>
          <li v-if="(!filteredItems || !filteredItems.length) && !loading" class="panel-item">
            <component :is="currentListItemView" :item="false"></component>
          </li>
        </virtual-scroll>
      </ul>
    </div>
    <!-- End of list column -->
    <!-- Start of item column -->
    <component :is="currentView" :item="selectedItem" class="content-panel"></component>
    <!-- End of item column -->
  </section>
</template>

<script>
import $ from 'jquery'
import escapeRegExp from 'escape-string-regexp'
import campaign from './campaign.vue';
import rotator from './rotator.vue';
import campaignListItem from './campaign-list-item.vue';
import rotatorListItem from './rotator-list-item.vue';
import virtualScroll from 'vue-virtual-scroll-list';

export default {
  name: 'aroma',
  components: {
    campaign, rotator, campaignListItem, rotatorListItem, virtualScroll
  },
  data() {
    return {
      loading           : true,
      currentView       : this.$route.meta.type,
      selected          : null,
      selectedCategory1 : '',
      selectedCategory2 : '',
      searchText        : ''
    }
  },

  mounted() {
    this.selectItem(this.$route.params && this.$route.params.id)
    this.initialize()
  },
  watch: {
    // Reset state
    '$route': function(newVal, oldVal) {
      this.selectItem(newVal.params.id)

      if (newVal.meta.type != oldVal.meta.type && newVal.meta.type) {
        this.loading              = true;
        this.currentView          = this.$route.meta.type;
        this.searchText           = '';
        this.selectedCategory1    = this.selectedCategory2 = null;

        this.initialize();
      }
    }
  },
  computed: {
    categoryOne() {
      return this.categories(1)
    },
    categoryTwo() {
      return this.categories(2)
    },
    currentList() {
      return this.currentView && (this.currentView + 's')
    },
    currentListItemView() {
      return this.currentView && (this.currentView + '-list-item')
    },
    items() {
      const items  = this.$store.state.cache[this.currentList] || []

      // item not found, redirect the user
      if (!this.loading && this.selected && this.selected != 'create' && !items.some(item => item.id == this.selected)) {
        this.$notify({
          title    : 'Error',
          message  : (this.currentView.charAt(0).toUpperCase() + this.currentView.slice(1)) + ' does not exist',
          position : 'bottom-right'
        })
        this.selectItem(null)
      }

      return items
    },
    selectedItem() {
      return this.selected == 'create'
           ? { id: this.selected }
           : (this.items.find((item) => item.id == this.selected) || this.selected)
    },
    filteredItems() {
      const regex = new RegExp(escapeRegExp(this.searchText), 'i');
      return this.items
                 .filter((item) => {
                   if (this.searchText && this.searchText.length >= 2)
                     return Object.keys(item).some((prop) => regex.test(JSON.stringify(item[prop])))
                   else
                     return item.default == true;
                 })
                 .filter(item => !this.selectedCategory1 || this.selectedCategory1 == '*' || (item.category_1 && item.category_1.indexOf(this.selectedCategory1) !== -1 ))
                 .filter(item => !this.selectedCategory2 || this.selectedCategory2 == '*' || (item.category_2 && item.category_2.indexOf(this.selectedCategory2) !== -1))
    }
  },
  methods: {
    initialize() {
      this.loading = true
      this.currentList && this.$store.dispatch('retrieve' + this.currentList.charAt(0).toUpperCase() + this.currentList.slice(1))
          .then(() => {}, () => {})
          .then(() => this.loading = false) // essentially an "always" method
    },
    panelClass(item) {
      return 'panel-item ' + (item.id == this.selected? 'active': '');
    },
    categories(num) {
      const categories = []
      this.items.forEach(item => {
        if (typeof item['category_' + num] == 'string')
          categories.push(...item['category_' + num].split(','))
      })
      categories.sort()

      return [...new Set(categories)];
    },
    selectOption(e) {
      if (e.keyCode == 13)
        $('.el-select-dropdown:visible li:visible:eq(0)').click();
    },
    selectItem(id) {
      // If this is a create action, clear selected every time to force a new create event
      if (id == 'create' && this.selected == id)
        this.selected = null

      this.selected = id
      this.$store.commit('setPanel', id && 'data')

      if (id != this.$route.params.id)
        this.$router.replace({
          name: this.$route.name.replace('_id', '') + (id? '_id': ''),
          params: { ...this.$route.params, id }
        })
    },
    showMenu(e) {
      e.stopPropagation()
      this.$store.commit('setPanel', this.$store.state.activePanel != 'menu'? 'menu': null)
    }
  }
};
</script>

<style lang="scss" scoped>

/*====
 *
 ** PANELS
 *
   ====*/
.two-col-content.active-tab{
  padding-left: 0 !important;

  .panels{
    width: 250px;
  }
}
.panels
{ /*Panels*/
  height: 100%;
  overflow: hidden;
  padding: 0;
  .virtual-scroll-container {
    height: 100% !important;
    /deep/ > ul {
      margin-bottom: 32px !important;
    }
  }
  .panel-items
  { /*Panel Items*/
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    background: #005884;
    background: linear-gradient(to bottom,  #005884 1%,#2d7599 100%);
    height: calc(100% - 60px);
    box-sizing: border-box;
    padding-bottom: 30px;

    /deep/ .el-loading-mask {
      background: none;
      z-index: 21;
    }
    .el-loading-mask svg circle {
      stroke: #fff;
    }
    .offer-status{
      position: absolute;
      background-color: #ff0000;
      left: 15px;
      top: 29px;
      border-radius: 100%;
      width: 10px !important;
      height: 10px;
    }
    .low:before{
      content: 'LOW';
      position: absolute;
      display: block;
      z-index: 20;
      color: #fff;
      word-wrap: break-word;
    }
    .unpaired .offer-status{
      top: 41px;
    }
  }
  .footer {
    position: absolute;
    bottom: 0px;
    overflow: hidden;
    width: 100%;
    background: #489AC3;
    z-index: 2;
    height: 30px;
    line-height: 30px;
    color: #efefef;
    font-weight: 300;
    text-align: center;
    border-top: 1px solid #333;
    font-size: 14px;
  }
}
.content-panel /deep/ .slidein {
  height: 100%;
  overflow-y: auto;
  &.touch-scroll{
    -webkit-overflow-scrolling: touch;
  }
}
/*====
 *
 ** SEARCHBAR
 *
   ====*/
.filter-holder .el-select:nth-child(2) {
  margin-left: 3%;
}
.searchbar
{ /*Seachbar*/
  position: relative;
  height: 46px;
  padding: 10px 15px;
  background: #005079;
  border-bottom: 1px solid #004467;

  :-moz-placeholder {
    color: #333 !important;
  }
  ::-moz-placeholder {
    color: #333 !important;
  }
  :-ms-input-placeholder {
    color: #333 !important;
  }

  .new-rotator-btn {
    width: 90px;
    margin-left: 10px;
    padding: 6px 15px;
    line-height: 14px;
    font-size: 13px;
    font-weight: normal;
    border: none;
    float: right;
  }
  .mini-search-bar {
    width: calc(100% - 104px);
    position: relative;
  }

}

/*====
 *
 ** RESPONSIVE
 *
   ====*/
.menu-con {
  display: none;
}
@media(max-width: 1198px){
  .panels {
    .filter-holder {
      .select .el-select {
        width: calc((100% - 50px) / 2);
      }
      .el-select:nth-child(2) {
        margin-left: 6px;
      }
    }
  }
  /*
   * Menu Icon
   */
  .menu-icon {
    cursor: pointer;
    width: 30px;
    height: 30px;
    float: left;
    display: inline-block;
    margin: 7px 14px 0 0;

    &:hover {
      background-color: #023830 !important;
    }
    .menu-icon-inner
    { /*Menu Icon Inner*/
      padding-top: 3px;
      .bar{
        position: relative;
        width: 30px;
        height: 3px;
        margin: 0 auto;
        margin-bottom: 5px;
        background: #fff;
      }
    }
  }
}
@media(min-width: 1024px){
  .sidebar{
	width: 250px;
	position: fixed;
  }
  .panels{
	width: 375px;
	position: fixed
  }
}
@media(min-width: 1199px){
  .searchbar input[type="text"]{
	width: 100%;
  }
  .searchbar input[type="text"]:focus{
	width: 100%;
  }
  .searchbar input[type="submit"]{
	opacity: 0;
  }
  .searchbar input[type="text"]:focus + input[type="submit"]{
	visibility: visible;
	opacity: 1;
  }
  .panels .filter{
	margin-bottom: 0;
  }
  .sidebar{
 	left: 0 !important;
  }
  .two-col-content{
	width: 100%;
	padding-left: 250px !important;
  }
}

</style>



// WEBPACK FOOTER //
// aroma.vue?0be0a2ed